import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c2c6f932&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=c2c6f932&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c6f932",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2c6f932')) {
      api.createRecord('c2c6f932', component.options)
    } else {
      api.reload('c2c6f932', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c2c6f932&scoped=true&", function () {
      api.rerender('c2c6f932', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/taskManage/index.vue"
export default component.exports